/**
 * Map access (Lauren, 2026-10-21): anyone can look at the map, even without an account.
 * Contributing (resources, locations, notes, ratings, flags, messages) needs a free account.
 * Planning tours (create, add stops, save, share, import) needs Map access as before:
 * a VRC Member subscription, tour-party crew coverage, or admin.
 */
export const MAP_ACTION = {
  CONTRIBUTE: 'contribute',
  PLAN: 'plan',
};

/**
 * Guests who open a venue are signed in anonymously (VenueScreen), so auth.currentUser alone
 * is not an account. Only a non-anonymous Firebase user counts as signed in.
 */
export function isRealUser(user) {
  return !!user && !user.isAnonymous;
}

/** 'ok', 'signIn' (guest) or 'subscribe' (signed in, but tour planning is paid). */
export function getMapActionGate({ signedIn, canPlanTours, kind }) {
  if (!signedIn) return 'signIn';
  if (kind === MAP_ACTION.PLAN && !canPlanTours) return 'subscribe';
  return 'ok';
}

export function getMapPromptCopy(gate, kind) {
  if (gate === 'subscribe') {
    return {
      title: 'Tour planning is for members',
      body: 'Building, saving and sharing tours comes with a VRC Membership. You can keep exploring the map and adding resources for free.',
      primary: 'See membership',
    };
  }
  if (kind === MAP_ACTION.PLAN) {
    return {
      title: 'Sign in to plan a tour',
      body: 'The map is free to explore. Create an account or sign in to build routes, save tours and share them.',
      primary: 'Create Account',
    };
  }
  return {
    title: 'Sign in to add to the map',
    body: 'The map is free to explore. Create a free account to add resources, notes and ratings, and earn credits for what you share.',
    primary: 'Create Account',
  };
}
